import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";
import { Loading } from "components";

// Сторінка входу для розширення KeyCRM. Попап розширення відкриває її в
// новій вкладці замість власної форми: у попапі будь-який зайвий клік
// закриває вікно. Тут менеджер входить у ЦАУ як завжди (форма або Google),
// а content-скрипт розширення, що працює на цій адресі, забирає токен зі
// сховища сторінки. Обмін іде DOM-подіями: сторінка каже «токен готовий»,
// скрипт відповідає «забрав» або «немає доступу». Якщо ніхто не відповів,
// розширення не встановлене.

const EVENT_READY = "cau:extension-auth-ready"; // сторінка → розширення
const EVENT_OK = "cau:extension-auth-ok"; // розширення → сторінка
const EVENT_DENIED = "cau:extension-auth-denied"; // розширення → сторінка

// Скрипт розширення може підвантажитись пізніше за React, тож сигнал
// повторюється, поки немає відповіді; після таймауту — «не знайдено».
const RETRY_MS = 500;
const TIMEOUT_MS = 5000;

const STATES = {
  waiting: {
    title: "Зв'язок із розширенням…",
    text: "Передаємо дані входу розширенню KeyCRM.",
  },
  ok: {
    title: "Авторизація успішна",
    text: "Можете закрити цю вкладку і повертатись у KeyCRM. Розширення вже увійшло у ваш акаунт.",
  },
  denied: {
    title: "Немає доступу до розширення",
    text: "Ваш акаунт ЦАУ не має дозволу на роботу з розширенням KeyCRM. Зверніться до адміністратора.",
  },
  missing: {
    title: "Розширення не знайдено",
    text: "Установіть розширення KeyCRM DB Helper у цьому браузері, відкрийте його попап і натисніть «Увійти через ЦАУ» ще раз.",
  },
};

const ExtensionAuthPage = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const [state, setState] = useState("waiting");

  useEffect(() => {
    if (loading || !isAuthenticated) return undefined;

    let settled = false;
    const settle = (next) => {
      settled = true;
      setState(next);
    };
    const onOk = () => settle("ok");
    const onDenied = () => settle("denied");
    window.addEventListener(EVENT_OK, onOk);
    window.addEventListener(EVENT_DENIED, onDenied);

    const ping = () => window.dispatchEvent(new Event(EVENT_READY));
    ping();
    const retry = setInterval(() => (settled ? clearInterval(retry) : ping()), RETRY_MS);
    const timeout = setTimeout(() => {
      if (!settled) setState("missing");
    }, TIMEOUT_MS);

    return () => {
      window.removeEventListener(EVENT_OK, onOk);
      window.removeEventListener(EVENT_DENIED, onDenied);
      clearInterval(retry);
      clearTimeout(timeout);
    };
  }, [loading, isAuthenticated]);

  if (loading) return <Loading />;
  if (!isAuthenticated) {
    return <Navigate to="/login?next=/extension-auth" replace />;
  }

  const view = STATES[state];

  return (
    <main>
      <section id="ext-auth">
        <div className={`ext-auth-card is-${state}`}>
          <div className="ext-auth-mark" aria-hidden="true" />
          <h1>{view.title}</h1>
          <p>{view.text}</p>
          {user && (
            <p className="ext-auth-user">
              Ви увійшли як <strong>{user.username || user.email}</strong>
            </p>
          )}
          {state === "missing" && (
            <button type="button" onClick={() => window.location.reload()}>
              Спробувати ще раз
            </button>
          )}
        </div>
      </section>
    </main>
  );
};

export default ExtensionAuthPage;
